import React from 'react';
import useCopy from '../util/useCopy';

const getTimeFromNow = ({ toTimestamp, copy }) => {
  const difference = toTimestamp - Date.now();

  if (difference <= 0) return copy.now;

  const day = Math.floor(difference / (1000 * 60 * 60 * 24));

  return Object.entries(
    day
      ? {
          day,
          hour: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minute: Math.floor((difference / 1000 / 60) % 60),
        }
      : {
          hour: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minute: Math.floor((difference / 1000 / 60) % 60),
          second: Math.floor((difference / 1000) % 60),
        },
  )
    .map(([label, value]) => `${value} ${copy[label]}${value === 1 ? '' : 's'}`)
    .join(' ');
};

const Countdown = ({ toTimestamp }) => {
  const copy = useCopy();

  const [timeLeft, setTimeLeft] = React.useState(() =>
    getTimeFromNow({ copy, toTimestamp }),
  );

  React.useEffect(() => {
    const timeout = setInterval(() => {
      setTimeLeft(getTimeFromNow({ copy, toTimestamp }));
    }, 1000);

    return () => {
      clearInterval(timeout);
    };
  }, [toTimestamp, copy]);

  return <span className="Countdown">{timeLeft}</span>;
};

export default Countdown;
